import { isOplotFlavor } from "@/env/env";

type TLogoMode = "light" | "dark";

interface IGetDefaultLogoUrlProps {
  mode: TLogoMode;
}

interface IGetLogoUrlProps {
  mode: TLogoMode;
  cacheBuster?: number | null;
  isOrgBrandingEnabled?: boolean;
}

const getDefaultLogoUrl = ({ mode }: IGetDefaultLogoUrlProps): string => {
  const logoPrefix = isOplotFlavor() ? "/oplot-logo" : "/logo";

  return `${logoPrefix}-${mode}.svg`;
};

export const getLogoUrl = ({
  mode,
  cacheBuster,
  isOrgBrandingEnabled = true,
}: IGetLogoUrlProps): string => {
  if (!isOrgBrandingEnabled) {
    return getDefaultLogoUrl({ mode });
  }

  const cacheBusterParam = cacheBuster ? `&cacheBuster=${cacheBuster}` : "";

  return `/api/theme/logo?mode=${mode}${cacheBusterParam}`;
};
